<template>
    <div>
      <div>
        <div ref='chartAerial' style='width:90%; height: 300px'></div>
        <div ref='aeriaToolbox' style='right: 10px; top: 0px; width: 160px; height: 10px;'></div>
      </div>
      <div>
        <div ref='chartRb' style='width:90%; height: 300px'></div>
      </div>
      <div id='divParams' style='display: none;'></div>
    </div>
</template>

<script>
import echarts from 'echarts';
import Vue from 'vue';
import { EventBus } from '../../../plugins/eventBus';

Vue.prototype.$echarts = echarts;
export default {
  name: 'SpectrumChart',
  components: {
    // echarts
  },
  data() {
    return {
      neid: '',
      aerialSeries: [],
      rbSeries: [],
      rbXAxisData: '',
      rbXAxisLen: 100,
      rbYAxisData: '',
      key: null, // 数据集编号
      aerialData: [], // 全量aerial数据集
      rbData: {}, // rb数据
      aerialChart: null, // 天线图表
      rbChart: null, // 时频图表
      stop: false, // 停止更新视图
      firstTime: null, // 第一条扫频数据时间
      respTimes: null, // 扫频数据响应次数
      refreshTime: 30 * 60 * 1000,
      rssiSize: null, // 天线条数
      hashMap: null,
      stopItem: null,
      spikItem: null,
      meanItem: null,
      exportItem: null,
      stopColor: '#CCC',
      spikColor: '#CCC',
      meanColor: '#CCC',
      exportColor: '#CCC'
    };
  },
  mounted() {
    this.init();
    this.initAerialChart();
    this.initChartRb();
  },
  methods: {
    init() {
      // 存储带宽值
      this.hashMap = new Map();
      this.hashMap.set('6', '1.4MHz').set('15', '3MHz').set('25', '5MHz').set('50', '10MHz')
        .set('75', '15MHz')
        .set('100', '20MHz')
        .set('40', '8MHz');
    },
    selectTime(time, resp) { // 时间选取
      // 获取浏览器客户端相比格林威治时区偏移
      const timeoffset = new Date().getTimezoneOffset() * 60000;
      if (time <= (resp.resptime + timeoffset + resp.timeOffSet)) {
        const rbData = [];
        resp.rbs.forEach((rb, i) => {
          rb.rssis.forEach((rssi, j) => {
            rbData.push([j, i, rssi]);
          });
        });

        this.rbSeries = {
          data: rbData
        };
        this.rbChart.setOption({
          title: {
            subtext: new Date(resp.resptime + timeoffset + resp.timeOffSet).toLocaleString()
          },
          series: [{
            data: rbData
          }]
        });
      }
    },
    /**
     * 同步数据集
     */
    syncDatas() {
      // this.initAerialChart();//避免切换基站时天线图表显示数据有问题
      // 天线数据同步
      let aerialTempData = [[], [], [], [], [], [], [], []];
      let tempRssiSize = null;
      if (this.rssiSize != null) {
        aerialTempData = aerialTempData.splice(0, this.rssiSize);
      } else if (this.aerialData != null && this.aerialData.length > 0) {
        tempRssiSize = this.aerialData[0].aerials[0].rssi.length;
        if (this.rssiSize !== tempRssiSize) {
          this.rssiSize = this.aerialData[0].aerials[0].rssi.length;
          // this.SpectrumChart.init('chartAerial', 'chartRb');
        }
        aerialTempData = aerialTempData.splice(0, this.rssiSize);
      }
      this.aerialData.forEach((resp) => {
        const time = new Date(resp.resptime);
        resp.aerials[0].rssi.forEach((data, i) => {
          aerialTempData[i].push({
            value: [time, data]
          });
        });
      });
      const series1 = [];
      aerialTempData.forEach((data1) => {
        series1.push({ data: data1 });
      });

      this.aerialChart.setOption({ series: series1 });

      // 时频数据同步
      // this.$echarts.dispose(this.$refs.chartRb);
      const rbTempData = [];
      let time = null;
      if (Object.keys(this.rbData).length !== 0) {
        time = new Date(this.rbData.resptime).toLocaleString();
        this.rbData.rbs.forEach((rb, i) => {
          rb.rssis.forEach((rssi, j) => {
            rbTempData.push([j, i, rssi]);
          });
        });
      }
      const bandWidth = Object.keys(this.rbData).length === 0 ? null : this.hashMap.get(`${this.rbData.rbs[0].rssis.length}`);
      // X坐标轴重新设置
      this.rbXAxisLen = Object.keys(this.rbData).length === 0 ? 100 : (this.rbData.rbs[0].rssis.length);

      this.rbChart.setOption({
        title: {
          subtext: time
        },
        series: [{
          data: rbTempData
        }],
        xAxis: {
          name: bandWidth,
          data: this.rbXAxisData()
        }
      });
    },
    /**
     * 执行导出图片动作
     */
    doExport(canvas) {
      const url = canvas.toDataURL();
      const $a = document.createElement('a');
      const data = new Date();
      const month = data.getMonth() + 1;
      let minute = data.getMinutes();
      let second = data.getSeconds();
      if (minute < 10) {
        minute = minute.toString().padStart(2, '0');
      }
      if (second < 10) {
        second = second.toString().padStart(2, '0');
      }
      // const dataString = data.getFullYear() + '-' + month + '-' + data.getDate() + ' ' + data.getHours() + '.' + minute + '.' + second;
      const dataString = `${data.getFullYear()}-${month}-${data.getDate()} ${data.getHours()}.${minute}.${second}`;
      $a.download = `${this.$t('Spectrum.ui_pt_spectrumsca')}${dataString}.png`;
      $a.target = '_blank';
      $a.href = url;
      // Chrome and Firefox
      if (typeof MouseEvent === 'function') {
        const evt = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false
        });
        $a.dispatchEvent(evt);
      } else {
        const html = `<body style="margin:0;"><img src="${url}" style="max-width:100%;" title=I18Message.spectrumSca/></body>`;
        const tab = window.open();
        tab.document.write(html);
      }
    },
    initAerialChart() {
      // 释放占用的内存
      this.$echarts.dispose(this.$refs.chartAerial);
      this.aerialChart = this.$echarts.init(this.$refs.chartAerial);
      let legend = ['ANT0', 'ANT1', 'ANT2', 'ANT3', 'ANT4', 'ANT5', 'ANT6', 'ANT7'];
      const $that = this;
      if (this.rssiSize != null) {
        legend = legend.splice(0, this.rssiSize);
      }
      legend.forEach((name1) => {
        this.aerialSeries.push({
          name: name1,
          type: 'line',
          showSymbol: false,
          data: [],
        });
      });
      const This = this;
      // 绘制图表
      this.aerialChart.setOption({
        legend: {
          data: legend
        },
        title: {
          text: this.$t('Spectrum.ui_pt_spectrumantdgm'),
          textAlign: 'center',
          left: 240
        },
        tooltip: {
          trigger: 'axis'
        },
        dataZoom: {
          start: 50,
          end: 100
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          },
          name: this.$t('Spectrum.ui_pt_spectrumtimlin')
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          },
          min: -130,
          max: -0,
          name: this.$t('Spectrum.ui_pt_spectrumUnit')
        },
        series: this.aerialSeries,
        toolbox: {
          show: true, // 是否显示工具栏组件

          feature: {
            myStopItem: {
              show: true,
              title: this.$t('Spectrum.ui_pt_spectrumsuspendre'),
              // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
              icon: 'path://M193.88-54.51h239.18V822.51H193.88v-877.02z m397.05 0h239.18V822.51H590.93v-877.02z',
              iconStyle: {
                // color: '#000fff',
                borderColor: '#CCC'
              },
              onclick() {
                const flag = This.stopRefresh();
                if (flag) {
                  // This.stopColor = '#15aaef';
                  this.model.option.iconStyle.borderColor = '#0000ff';
                } else {
                  this.model.option.iconStyle.borderColor = '#CCC';
                }
                This.aerialChart.setOption({ tooltip: {
                  trigger: 'axis' }
                });
              }
            },
            mySpikItem: {
              title: this.$t('Spectrum.ui_pt_spectrumpeakmon'),
              // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
              // icon: 'path://M960-17.58V632.58H60.99v-650.17H960v0.01zM99.24 20.64V594.35h822.5v-573.71H99.24zM749.59 398.1v10.04c0 49.94-40.65 90.59-90.6 90.59h-10.08c-49.96 0-90.6-40.65-90.6-90.59v-10.04c0-49.96 40.63-90.58 90.6-90.58h10.08c49.95 0 90.6 40.61 90.6 90.58zM659 460.49c28.86 0 52.34-23.48 52.34-52.35v-10.04c0-28.89-23.48-52.37-52.34-52.37h-10.08c-28.86 0-52.34 23.48-52.34 52.37v10.04c0 28.87 23.48 52.35 52.34 52.35H659zM91.37 81.78l277.19 282.17-27.29 26.8L64.08 108.56l27.29-26.78z m514.76 34.49l27.05 27.03-269.36 269.3-27.05-27.04 269.36-269.29z m188.29 159.46l-27.35 26.73-171.92-175.81 27.35-26.74 171.92 175.82z m135.69-152.5l27.16 26.91-170.19 171.72-27.16-26.95 170.19-171.68z m-8.37 547.6v38.25H99.24v-38.25h822.5z m-765.11 76.49h707.74v38.26H156.63v-38.26z',
              icon: 'path://M134.4 246.39999999999998c-22.4 0-44.8-19.2-44.8-44.8v-262.4c0-25.6 19.2-44.8 41.6-44.8 25.6 0 44.8 19.2 44.8 41.6V201.60000000000002c3.2 25.6-16 44.8-41.6 44.8Zm249.6 278.4c-22.4 0-44.8-19.2-44.8-44.8v-540.8c0-25.6 19.2-44.8 44.8-44.8 25.6 0 44.8 19.2 44.8 44.8V480c0 25.6-19.2 44.8-44.8 44.8Zm499.2 0c-22.4 0-44.8-19.2-44.8-44.8v-540.8c0-25.6 19.2-44.8 41.6-44.8 25.6 0 44.8 19.2 44.8 41.6V480c3.2 25.6-16 44.8-41.6 44.8Zm-249.6-208c-22.4 0-44.8-19.2-44.8-44.8v-332.8c0-25.6 19.2-44.8 44.8-44.8 25.6 0 44.8 19.2 44.8 44.8V272c0 22.4-19.2 41.6-44.8 44.8ZM953.6 873.6h-156.8c-25.6 0-41.6-22.4-41.6-44.8s19.2-41.6 41.6-41.6h51.2L640 579.2l-211.2 211.2c-16 16-41.6 16-60.8 0l-3.2-3.2L35.2 460.8c-16-16-16-44.8 0-60.8s44.8-16 60.8 0l300.8 300.8 208-208s0-3.2 3.2-3.2c6.4-6.4 12.8-9.6 22.4-12.8h3.2c12.8-3.2 25.6 3.2 35.2 12.8l240 240V672c0-25.6 19.2-44.8 41.6-44.8 25.6 0 44.8 19.2 44.8 41.6v160c3.2 25.6-16 44.8-41.6 44.8Z',
              iconStyle: {
                // color: '#000fff',
                borderColor: '#CCC'
              },
              onclick() {
                const flag = This.startSpikMonitor();
                if (flag) {
                  // this.spikColor = '#15aaef';
                  this.model.option.iconStyle.borderColor = '#0000ff';
                } else {
                  // this.spikColor = '#CCC';
                  this.model.option.iconStyle.borderColor = '#CCC';
                }
                This.aerialChart.setOption({ tooltip: { trigger: 'axis' }
                });
              }
            },
            myMeanItem: {
              title: this.$t('Spectrum.ui_pt_spectrumavemon'),
              // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
              // icon: 'path://M76.47 559.8h871.05V737.85H76.47V559.8z m0-264h871.05V473.85H76.47V295.8z m0-265.65h871.05V208.2H76.47v-178.05z',
              // icon: 'path://M966.4 96V697.6c0 28.8-22.4 51.2-51.2 51.2H112c-28.8 0-51.2-22.4-51.2-51.2V96H38.4C16 96 0 80 0 57.6s16-38.4 38.4-38.4h947.2c22.4 0 38.4 16 38.4 38.4S1008 96 985.6 96h-19.2z m-83.2 0H140.8V672h742.4v-576zM766.4 540.8c0 22.4-16 40-40 40H268.8c-22.4 0-40-16-40-40s16-40 40-40h459.2c19.2-3.2 38.4 14.4 38.4 40zM272 428.8c-22.4 0-40-16-40-40s16-40 40-40h220.8c22.4 0 40 16 40 40s-16 40-40 40H272zM272 276.8c-22.4 0-40-16-40-40 0-22.4 16-40 40-40h364.8c22.4 0 40 16 40 40 0 22.4-16 40-40 40H272z',
              icon: 'path://M118.4 649.6h54.4v-28.8c0-28.8 25.6-54.4 54.4-54.4s54.4 25.6 54.4 54.4v28.8h617.6c35.2 0 60.8 25.6 60.8 54.4s-25.6 54.4-54.4 54.4H284.8v32c0 28.8-25.6 54.4-54.4 54.4s-54.4-22.4-54.4-54.4v-28.8H118.4C89.6 758.4 64 732.8 64 704s25.6-54.4 54.4-54.4z m787.2-531.2H284.8v28.8c0 28.8-25.6 54.4-54.4 54.4s-54.4-25.6-54.4-54.4v-28.8H118.4c-28.8 0-54.4-25.6-54.4-54.4 0-28.8 25.6-54.4 54.4-54.4h54.4v-28.8c0-28.8 25.6-54.4 54.4-54.4s54.4 25.6 54.4 54.4v28.8h617.6c28.8 0 54.4 25.6 54.4 54.4 6.4 28.8-19.2 54.4-48 54.4z m0 320h-54.4v28.8c0 28.8-25.6 54.4-54.4 54.4s-54.4-25.6-54.4-54.4v-28.8H118.4c-28.8 0-54.4-25.6-54.4-54.4 0-28.8 25.6-54.4 54.4-54.4H736v-28.8c0-28.8 25.6-54.4 54.4-54.4 28.8 0 54.4 25.6 54.4 54.4v28.8h54.4c28.8 0 54.4 25.6 54.4 54.4 6.4 28.8-19.2 54.4-48 54.4z',
              iconStyle: {
                // color: '#000fff',
                borderColor: '#CCC'
              },
              onclick() {
                const flag = This.startMeanMonitor();
                if (flag) {
                  this.model.option.iconStyle.borderColor = '#0000ff';
                } else {
                  this.model.option.iconStyle.borderColor = '#CCC';
                }
                This.aerialChart.setOption({
                  tooltip: { trigger: 'axis' }
                });
              }
            },
            myExportItem: {
              show: true,
              title: This.$t('Spectrum.ui_pt_spectrumexpimg'),
              // icon: 'M12.2,21.8c0.9,0,1.5-0.7,1.5-1.5l0,0v-8.4c0-0.9-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v8.4C10.7,21.1,11.4,21.8,12.2,21.8L12.2,21.8z M19.8,21.8c0.9,0,1.5-0.7,1.5-1.5l0,0v-8.4c0-0.9-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v8.4C18.2,21.1,18.9,21.8,19.8,21.8L19.8,21.8z M16,0.6C7.5,0.6,0.6,7.5,0.6,16S7.5,31.4,16,31.4S31.4,24.5,31.4,16S24.5,0.6,16,0.6z M16,28.5C9.1,28.5,3.5,22.9,3.5,16S9.1,3.5,16,3.5S28.5,9.1,28.5,16l0,0C28.5,22.9,22.9,28.5,16,28.5z',
              // icon: 'path://M754.53 119.74V170.4l92.02 75.69v-172.36c0-25.44-20.57-46.01-46.01-46.01H110.36c-25.44 0-46.01 20.57-46.01 46.01V609.86c0 25.35 20.57 46.01 46.01 46.01h265.26c-68.14-50.8-99.85-92.02-99.85-92.02h-119.4v-444.11h598.16zM285.21 235.6s0 366.62 370.9 366.62V746.28l305.47-230.01-305.47-239.31V440.35c-201.3 0-265.9-32.3-370.9-204.75z',
              // icon: 'path://M832 806.4c-12.8 19.2-28.8 38.4-48 48-19.2 12.8-41.6 16-83.2 16h-307.2c-25.6-6.4-32-6.4-44.8-6.4-12.8-3.2-25.6-9.6-32-12.8-12.8-9.6-19.2-12.8-32-28.8L70.4 624c-16-16-25.6-25.6-32-38.4-9.6-12.8-12.8-19.2-16-38.4-6.4-9.6-6.4-22.4-6.4-41.6v-464c0-41.6 3.2-60.8 16-80 12.8-19.2 28.8-38.4 48-48 19.2-12.8 41.6-16 83.2-16h534.4c19.2 0 41.6 16 41.6 41.6 0 19.2-16 41.6-41.6 41.6H160c-28.8 0-38.4 0-44.8 3.2s-12.8 9.6-12.8 12.8c-6.4 6.4-6.4 16-6.4 44.8V480h281.6c25.6 0 44.8 19.2 44.8 44.8V790.4H704c28.8 0 38.4 0 44.8-3.2 9.6-3.2 12.8-9.6 12.8-12.8 6.4-9.6 6.4-19.2 6.4-48v-304c0-19.2 16-41.6 41.6-41.6s41.6 16 41.6 41.6V723.2c-6.4 41.6-6.4 60.8-19.2 83.2z m-489.6-246.4H115.2l9.6 9.6L339.2 768l9.6 9.6v-217.6h-6.4zM992 172.8c32-32 32-83.2 0-115.2l-144-144c-16-16-41.6-16-57.6 0s-16 41.6 0 60.8l102.4 102.4h-291.2c-22.4 0-41.6 19.2-41.6 41.6 0 22.4 19.2 41.6 41.6 41.6h291.2l-105.6 102.4c-16 16-16 41.6 0 60.8 16 16 41.6 16 57.6 0l147.2-150.4z',
              icon: 'path://M237.929 667.106h391.529c204.8 0 370.447-165.647 370.447-367.435S834.259-67.76499999999998 629.459-67.76499999999998H135.529c-33.1294 0-60.2353 27.1059-60.2353 60.2353s27.1059 60.2353 60.2353 60.2353h493.929c135.529 0 246.965 108.424 246.965 246.965s-111.435 246.965-246.965 246.965H234.918l72.2824-72.2824c24.0941-24.0941 24.0941-63.2471 3.01177-87.3412-9.03529-9.03529-18.0706-15.0588-30.1176-18.0706-21.0824-6.02353-45.1765 0-60.2353 18.0706l-174.682 174.682c-24.0941 24.0941-24.0941 63.2471 0 87.3412l174.682 174.682c24.0941 24.0941 63.2471 24.0941 87.3412 0 24.0941-24.0941 24.0941-63.2471 0-87.3412L237.929 667.106Z',
              iconStyle: {
                // color: '#000fff',
                borderColor: '#CCC'
              },
              onclick() {
                This.exportImage();
              }
            }
          }
        }
      });

      // 注册天线图表点击事件
      this.aerialChart.on('click', function (param) {
        if (param.componentType === 'series') {
          const spectrumId = $that.getKey();
          const time = param.value[0].getTime();
          const params = {
            neid: $that.neid,
            id: spectrumId,
            starttime: time
          };
          $that.$axios.post('/lte/ems/spectrum/selectSpectrumDataByTime.html', params).then((response) => {
            if (response && response.status === 200) {
              if (response.data.errorCode === 'SUCCESS') {
                $that.selectTime(time, response.data.resultVal);
              } else {
                EventBus.$emit('toast', { type: 'warning', content: this.$ts(`Spectrum.${response.data.errorCode}`) });
              }
            }
          });
        }
      });
    },
    initChartRb() {
      this.$echarts.dispose(this.$refs.chartRb);
      this.rbChart = this.$echarts.init(this.$refs.chartRb);
      this.rbXAxisLen = Object.keys(this.rbData).length === 0 ? 100 : (this.rbData.rbs[0].rssis.length);
      const bandWidth = Object.keys(this.rbData).length === 0 ? null : this.hashMap.get(`${this.rbXAxisLen}`);

      this.rbXAxisData = () => {
        const arr = [];
        for (let i = 0; i < this.rbXAxisLen; i++) {
          arr.push(i);
        }
        return arr;
      };
      this.rbYAxisData = () => {
        const arr = [];
        for (let i = 0; i < 10; i++) {
          arr.push(i);
        }
        return arr;
      };
      this.rbSeries = [{
        name: this.$t('Spectrum.ui_pt_rbOption'),
        type: 'heatmap',
        data: [],
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }];
      this.rbChart.setOption({
        title: {
          text: this.$t('Spectrum.ui_pt_spectrumfredgm'),
          textAlign: 'center',
          left: 280
        },
        tooltip: {
          position: 'right',
          formatter(param1) {
            return `${param1.seriesName}<br/>(${param1.data[0]},${param1.data[1]}): ${param1.data[2]}`;
          }
        },
        xAxis: {
          type: 'category',
          splitArea: {
            show: true
          },
          name: bandWidth,
          data: this.rbXAxisData()
        },
        yAxis: {
          type: 'category',
          splitArea: {
            show: true
          },
          name: this.$t('Spectrum.ui_pt_spectrumchfindex'),
          data: this.rbYAxisData()
        },
        visualMap: {
          show: false,
          min: -127.5,
          max: 0,
          inRange: {
            color: ['#00ff00', '#009600', '#003200', '#320000', '#960000', '#ff0000']
          }
        },
        series: this.rbSeries
      });
    },
    setDatas(neid, spectrumId, datas) {
      this.initAerialChart();//避免切换基站时天线图表显示数据有问题
      const timeoffset = new Date().getTimezoneOffset() * 60000;
      // init cache
      this.key = spectrumId;
      this.neid = neid;
      this.aerialData = [];
      this.rbData = {};
      this.stop = false;
      this.firstTime = null;
      this.respTimes = 0;
      if (datas !== null && datas.length !== 0) {
        this.rssiSize = datas[0].aerials[0].rssi.length;
      } else {
        this.rssiSize = null;
      }
      if (datas !== null && Object.keys(datas).length !== 0) {
        // aerials数据集更新
        datas.forEach((resp) => {
          // const time = new Date(resp.resptime);
          this.aerialData.push({
            aerials: resp.aerials,
            resptime: resp.resptime + timeoffset + resp.timeOffSet
          });
        });
        // rbs数据集更新
        if (datas !== null && datas.length > 0) {
          this.firstTime = datas[0].resptime + timeoffset + datas[0].timeOffSet;
          const lastData = datas[datas.length - 1];
          this.rbData = {
            rbs: lastData.rbs,
            resptime: lastData.resptime + timeoffset + lastData.timeOffSet
          };
          this.respTimes = parseInt(((lastData.resptime + timeoffset + lastData.timeOffSet) - this.firstTime) / this.refreshTime, 10);
        }
      } else {
        this.aerialData = [];
        this.rbData = [];
        this.respTimes = null;
      }
      this.syncDatas();
    },
    getKey() {
      return this.key;
    },
    addData(spectrumId, data) {
      const timeoffset = new Date().getTimezoneOffset() * 60000;
      if (this.key === spectrumId) {
        if (this.firstTime === null) {
          this.firstTime = data.resptime + timeoffset + data.timeOffSet;
        }
        const totalTime = ((data.resptime + timeoffset + data.timeOffSet) - this.firstTime);
        const times = parseInt(totalTime / this.refreshTime, 10);// how many 30 mins
        if (times > this.respTimes) {
          this.respTimes = times;
        }
        let leftTime = data.resptime + timeoffset + data.timeOffSet;
        if (this.aerialData.length > 0) {
          leftTime = this.aerialData[0].resptime;
        }
        if ((data.resptime + timeoffset + data.timeOffSet) - leftTime > this.refreshTime) {
          this.aerialData.splice(0, 1);
        }
        const tempAerialData = { aerials: data.aerials, resptime: (data.resptime + timeoffset + data.timeOffSet) };
        const tempRbData = { rbs: data.rbs, resptime: (data.resptime + timeoffset + data.timeOffSet) };
        if (this.aerialData.length > 30) {
          // console.log("this.aerialData.length > 30 is :" + true);
          // this.aerialData.shift();
          this.aerialData.splice(0, this.aerialData.length-30);
          console.log("before aerialData length is :" + this.aerialData.length);
        }
        this.aerialData.push(tempAerialData);
        console.log("after aerialData length is :" + this.aerialData.length);
        this.rbData = tempRbData;
        if (!this.stop) {
          this.syncDatas();
        }
      }
    },
    stopRefresh() {
      this.stop = !this.stop;
      return this.stop;
    },
    startSpikMonitor() {
      const option = this.$echarts.getInstanceByDom(this.$refs.chartAerial)._api.getOption();
      let marPoint = null;
      if (!option.series[0].markPoint) {
        marPoint = { data: [{ type: 'max', name: this.$t('Spectrum.ui_pt_spectrummax') }, { type: 'min', name: this.$t('Spectrum.ui_pt_spectrummin') }] };
      }
      const series1 = [];
      for (let i = 0; i < option.series.length; i++) {
        series1.push({ markPoint: marPoint });
      }
      this.aerialChart.setOption({ series: series1 });
      return marPoint != null;
    },
    startMeanMonitor() {
      const option = this.$echarts.getInstanceByDom(this.$refs.chartAerial)._api.getOption();
      let markLine1 = null;
      if (!option.series[0].markLine) {
        markLine1 = { data: [{ type: 'average', name: this.$t('Spectrum.ui_pt_spectrumave') }] };
      }
      const series1 = [];
      for (let i = 0; i < option.series.length; i++) {
        series1.push({ markLine: markLine1 });
      }
      this.aerialChart.setOption({ series: series1 });
      return markLine1 != null;
    },
    exportImage() {
      const width1 = this.$refs.chartAerial.getElementsByTagName('canvas')[0].width;
      const height1 = this.$refs.chartAerial.getElementsByTagName('canvas')[0].height;
      const height2 = this.$refs.chartRb.getElementsByTagName('canvas')[0].height;

      const url1 = this.$echarts.getInstanceByDom(this.$refs.chartAerial)._api.getConnectedDataURL({
        type: 'png',
        backgroundColor: '#FFF'
      });
      const url2 = this.$echarts.getInstanceByDom(this.$refs.chartRb)._api.getConnectedDataURL({
        type: 'png',
        backgroundColor: '#FFF'
      });
      let index = 0;
      // 产生告警节点的画布
      const tmpCanvas = document.createElement('canvas');
      const tmpctx = tmpCanvas.getContext('2d');
      tmpctx.clearRect(0, 0, width1, height1 + height2);
      tmpCanvas.width = width1;
      tmpCanvas.height = height1 + height2;
      const img1 = new Image();
      img1.src = url1;
      const This = this;
      img1.onload = function () {
        tmpctx.drawImage(img1, 0, 0);
        index++;
        if (index === 2) {
          This.doExport(tmpCanvas);
        }
      };
      const img2 = new Image();
      img2.src = url2;
      img2.onload = function () {
        tmpctx.drawImage(img2, 0, height1);
        index++;
        if (index === 2) {
          This.doExport(tmpCanvas);
        }
      };
    }
  }
};

</script>

<style scoped>

</style>
